function InfoRow({
  label,
  value,
  labelClassName = "",
  valueClassName = "",
  className = "",
}) {
  return (
    <div className={`grid grid-cols-2 gap-5 px-4 py-2 ${className}`}>
      <dt
        className={`text-sm/6 font-medium text-gray-900 ${labelClassName}`}
      >
        {label}
      </dt>

      <dd
        className={`mt-1 text-sm/6 text-gray-700 sm:mt-0 ${valueClassName}`}
      >
        {value ?? "-"}
      </dd>
    </div>
  );
}

export default InfoRow;